import React from 'react';
import Trophy from 'react-icons/lib/fa/trophy';
import PropTypes from "prop-types";

import CardContainer from 'react/containers/CardContainer';
import Articles from 'react/views/articles/Articles';
import { getArticles } from 'data/ArticleSelector';
import { getTitleUi } from 'data/TitleInfoSelector';
import { getJsonData } from "data/DataStore";
import AwardWinnersEventTypes from 'data/types/AwardWinnersEventTypes';

const AwardWinnersContainer = (props) => {
	return (
		<CardContainer
			aboutText="Discover awards won by this book"
			cardModel={getArticles("Award Winners")}
			component={Articles}
			countText="Awards won"
			icon={Trophy}
			iconColor='goldenrod'
			loggingId={getTitleUi(getJsonData())}
			title="Award Winners"
			eventType={AwardWinnersEventTypes.AWARDWINNERS_NAME_CLICKED}
			{...props}
		/>
	);
}

AwardWinnersContainer.propTypes = {
	onNullRender: PropTypes.func
};

export default AwardWinnersContainer;



// WEBPACK FOOTER //
// ./src/react/containers/AwardWinnersContainer.jsx